module.exports = __webpack_public_path__ + "wxres/vue/img/setup003.a80fafc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/setup003.jpg
// module id = EqSF
// module chunks = 59 60 62 63 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 79 80 81 82